module.exports = __webpack_public_path__ + "img/clear-popup-w.41548576.svg";